module.exports = __webpack_public_path__ + "img/business-studies.0bdfe47b.svg";